<template>
  <div>
    <a-card :bordered="false" class="search-wrapper">
      <a-form-model
        ref="searchFormRef"
        :model="searchForm"
        layout="inline"
        :label-col="{ style: { width: '84px' } }"
        @keyup.enter.native="handleSearch"
      >
        <a-form-model-item label="二维码编号" prop="qrcode">
          <a-input v-model="searchForm.qrcode" placeholder="请输入二维码编号" allow-clear />
        </a-form-model-item>

        <a-form-model-item label="认证码" prop="authCode">
          <a-input v-model="searchForm.authCode" placeholder="请输入认证码" allow-clear />
        </a-form-model-item>

        <a-form-model-item label="设备mac" prop="macAddress">
          <a-input v-model="searchForm.macAddress" placeholder="请输入设备mac地址" allow-clear />
        </a-form-model-item>

        <a-form-model-item label="型号名称" prop="modelName">
          <a-input v-model="searchForm.modelName" placeholder="请输入型号名称" allow-clear />
        </a-form-model-item>

        <a-form-model-item label="状态" prop="codeStatus">
          <a-select
            v-model="searchForm.codeStatus"
            placeholder="全部"
            allow-clear
            class="status-selector"
            style="width: 180px"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
              v-for="status in STATUS_LIST"
              :key="status.value"
              :value="status.value"
            >
              {{ status.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="上传日期" prop="dateRange">
          <a-range-picker v-model="dateRange" :placeholder="['开始时间', '结束时间']" allow-clear />
        </a-form-model-item>

        <a-form-model-item>
          <a-button @click="handleReset">重置</a-button>
          <a-button
            type="primary"
            :loading="loading"
            style="margin-left: 8px"
            @click="handleSearch"
          >
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>

    <a-card :bordered="false" class="table-wrapper">
      <!-- 工具栏 -->
      <div class="toolbar">
        <div class="right">
          <a-button type="primary" @click="uploadDialogVisible = true">上传二维码</a-button>
          <a-button
            type="primary"
            :loading="downloading"
            style="margin-left: 8px"
            @click="handleDownloadList"
          >
            下载打印列表
          </a-button>
        </div>
      </div>

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        :data-source="tableData"
        :columns="columns"
        :pagination="false"
        row-key="id"
        bordered
        size="middle"
      >
        <!-- 状态列自定义渲染 -->
        <template slot="codeStatus" slot-scope="text, record">
          <a-tag :color="getStatusTagType(record.codeStatus)">
            {{ record.codeStatusName }}
          </a-tag>
        </template>
      </a-table>

      <!-- 分页器 -->
      <div class="pagination-container">
        <a-pagination
          v-model="pagination.currentPage"
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          :page-size-options="['10', '20', '50']"
          show-size-changer
          show-quick-jumper
          :show-total="(total) => `共 ${total} 条`"
          @change="handleCurrentChange"
          @showSizeChange="handleSizeChange"
        />
      </div>
    </a-card>

    <upload-qrcode
      :visible.sync="uploadDialogVisible"
      @download="doDownload"
      @uploaded="fetchData"
    />
  </div>
</template>

<script>
import moment from "moment";
import { STATUS, STATUS_LIST } from "./constant";
import UploadQrcode from "./components/UploadQrcode.vue";
import { downloadQrcode, getQrcodeList } from "../../api/index/matter.js";

export default {
  components: { UploadQrcode },
  data() {
    return {
      STATUS_LIST,
      loading: false,
      tableData: [],
      searchForm: {
        qrcode: undefined,
        authCode: undefined,
        macAddress: undefined,
        modelName: undefined,
        codeStatus: "",
        uploadDateStart: undefined,
        uploadDateEnd: undefined,
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      columns: [
        {
          title: "序号",
          dataIndex: "serialNo",
          key: "serialNo",
          width: 60,
          ellipsis: true,
        },
        {
          title: "二维码编号",
          dataIndex: "qrCode",
          key: "qrCode",
          minWidth: 180,
          ellipsis: true,
        },
        {
          title: "认证码",
          dataIndex: "authCode",
          key: "authCode",
          minWidth: 150,
        },
        {
          title: "状态",
          dataIndex: "codeStatus",
          key: "codeStatus",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "codeStatus" },
        },
        {
          title: "型号名称",
          dataIndex: "modelName",
          key: "modelName",
          width: 120,
        },
        {
          title: "设备mac",
          dataIndex: "macAddress",
          key: "macAddress",
          minWidth: 160,
        },
        {
          title: "上传日期",
          dataIndex: "createTime",
          key: "createTime",
          minWidth: 160,
        },
      ],
      downloading: false,
      uploadDialogVisible: false,
    };
  },
  computed: {
    dateRange: {
      get() {
        const { uploadDateStart, uploadDateEnd } = this.searchForm;
        if (uploadDateStart && uploadDateEnd) {
          return [moment(uploadDateStart), moment(uploadDateEnd)];
        }
        return [];
      },
      set(value) {
        const [start, end] = value || [];
        if (start && end) {
          this.searchForm.uploadDateStart = moment(start).startOf("day").valueOf();
          this.searchForm.uploadDateEnd = moment(end).startOf("day").valueOf();
        } else {
          this.searchForm.uploadDateStart = undefined;
          this.searchForm.uploadDateEnd = undefined;
        }
      },
    },
    queryParams() {
      return {
        ...this.searchForm,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
    },
  },
  created() {
    this.handleSearch();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const { resultData: response } = await getQrcodeList(this.queryParams);
        this.pagination.total = response.total;
        this.tableData = response.records;
      } catch (error) {
        this.$message.error(error instanceof Error ? error.message : "获取列表失败");
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      return this.fetchData();
    },
    handleReset() {
      this.$refs.searchFormRef.resetFields();
      this.dateRange = [];
      this.pagination.currentPage = 1;
      return this.fetchData();
    },
    getStatusTagType(status) {
      const map = {
        [STATUS.PENDING_BIND]: "orange",
        [STATUS.BINDED]: "green",
        [STATUS.UNAVAILABLE]: "red",
      };
      return map[status];
    },

    async doDownload(payload, url) {
      this.$message.info("正在获取文件，准备下载...");

      const { blob, filename } = await downloadQrcode(url || "/matter/export", payload);
      const downloadFileName = filename || `matter-qrcode-${moment().format("YYMMDDHHmmss")}.xlsx`;

      // 创建内存临时 URL 并利用虚拟锚点触发浏览器下载
      const objectUrl = window.URL.createObjectURL(blob);
      const anchorElement = document.createElement("a");
      anchorElement.href = objectUrl;
      anchorElement.download = downloadFileName;
      anchorElement.hidden = true;

      try {
        document.body.appendChild(anchorElement);
        anchorElement.click();
      } finally {
        anchorElement.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0);
      }
    },

    // --- 下载列表逻辑 ---
    async handleDownloadList() {
      this.$confirm({
        title: "是否确认下载",
        content: "下载内容为当前列表筛选查询后展示的内容",
        onOk: async () => {
          this.downloading = true;
          try {
            await this.doDownload(
              { ...this.searchForm, codeStatus: this.searchForm.codeStatus || undefined },
              "matter/export/all"
            );
            this.$message.success("文件下载成功");
          } catch (error) {
            this.$message.error(error instanceof Error ? error.message : "文件下载失败");
          } finally {
            this.downloading = false;
          }
        },
      });
    },

    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchData();
    },
    handleSizeChange(current, size) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = size;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .right {
    margin-left: auto;
  }
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
